import { render } from "./VideoFile.vue?vue&type=template&id=53f64e26"
import script from "./VideoFile.vue?vue&type=script&lang=js"
export * from "./VideoFile.vue?vue&type=script&lang=js"
script.render = render

export default script